export const formatFileSize = (bytes) => {
  if (bytes == null || isNaN(bytes) || bytes < 0) return 'Unknown size';
  if (bytes < 1024) return `${bytes} B`;

  // For files smaller than 1MB, show in KB
  if (bytes < 1024 * 1024) {
    return `${parseFloat((bytes / 1024).toFixed(1))} KB`;
  }

  if (bytes >= 1024 * 1024 * 1024) {
    return `${parseFloat((bytes / (1024 * 1024 * 1024)).toFixed(1))} GB`;
  }

  return `${parseFloat((bytes / (1024 * 1024)).toFixed(1))} MB`;
};
